import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsForSection() {
  const isFor = ['Mamás de bebés entre 4 y 24 meses que ya no pueden más con el agotamiento.', 'Padres que buscan un método humano, empático y basado en la ciencia.', "Familias que quieren eliminar las 'luchas' de 2 horas para que el bebé se duerma."];
  const isNotFor = ["Padres que buscan el método de 'extinción total' (dejar al bebé solo hasta que deje de llorar).", 'Quienes no estén dispuestos a ajustar las luces y el ambiente de la casa por 15 minutos al día.'];
  return <section className="py-16 px-6 bg-white/50" data-id="element-199">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-200">
        <FadeIn data-id="element-201">
          <div className="bg-sage/10 rounded-3xl p-8 h-full" data-id="element-202">
            <h3 className="font-serif text-2xl text-taupe mb-6 flex items-center gap-2" data-id="element-203">
              <span className="bg-sage text-white rounded-full p-1" data-id="element-204">
                <CheckIcon className="w-5 h-5" data-id="element-205" />
              </span>
              Esto es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-206">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-taupe/80" data-id="element-207">
                  <CheckIcon className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-208" />
                  <span data-id="element-209">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-210">
          <div className="bg-lavender/10 rounded-3xl p-8 h-full" data-id="element-211">
            <h3 className="font-serif text-2xl text-taupe mb-6 flex items-center gap-2" data-id="element-212">
              <span className="bg-lavender text-white rounded-full p-1" data-id="element-213">
                <XIcon className="w-5 h-5" data-id="element-214" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-215">
              {isNotFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-taupe/80" data-id="element-216">
                  <XIcon className="w-5 h-5 text-lavender shrink-0 mt-0.5" data-id="element-217" />
                  <span data-id="element-218">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}